import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useMemo, useState } from 'react'
import Modal from './Modal'

interface Props {
  children: React.ReactElement | React.ReactElement[]
  minHeight?: string
  defaultOpen?: boolean
  callback?: VoidFunction
}

const UserGuide: FC<Props> = (props) => {
  const {
    children,
    minHeight,
    defaultOpen,
    callback,
  } = props

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [pageCount, setPageCount] = useState<number>(1)

  const pageLimit = useMemo(() => (
    Array.isArray(children) ? children.length : 0
  ), [isOpenModal])

  const nextPage = () => {
    if (pageLimit === pageCount) {
      setIsOpenModal(false)
      return
    }
    setPageCount(pageCount + 1)
  }

  useEffect(() => {
    if (defaultOpen) {
      setIsOpenModal(true)
    }
  }, [])

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (isOpenModal) {
      html.classList.add('modal_open')
    } else {
      html.classList.remove('modal_open')
      if (callback) callback()
    }
    setPageCount(1)
  }, [isOpenModal])

  return (
    <>
      <div className="user_guide_icon">
        <div
          className="icon"
          onClick={() => setIsOpenModal(true)}
          role="none"
        >
          <FontAwesomeIcon icon={['far', 'lightbulb']} />
        </div>
        <div className="user_guide_icon_text">
          機能紹介
        </div>
      </div>
      <Modal
        modalSize="large"
        show={isOpenModal}
        closeCallback={() => setIsOpenModal(false)}
        closeable
      >
        <>
          <div className="user_guide_modal">
            <div
              className="navigation_area"
              style={{
                backgroundColor: !!pageLimit && 1 < pageCount ? "#EEEEEE" : "transparent",
              }}
            >
              {
                !!pageLimit && 1 < pageCount && (
                  <>
                    <button
                      type="button"
                      onClick={() => setPageCount(pageCount - 1)}
                    >
                      <FontAwesomeIcon icon={['fas', 'caret-left']} />
                    </button>
                  </>
                )
              }
            </div>
            <div
              className="user_guide_main"
              style={{
                minHeight: minHeight || "unset",
              }}
            >
              <div
                className="next_filter"
                onClick={nextPage}
                role="none"
              />
              {Array.isArray(children) ? children[pageCount - 1] : children}
            </div>
            <div
              className="navigation_area"
              style={{
                backgroundColor: !!pageLimit && pageLimit > pageCount ? "#EEEEEE" : "transparent",
              }}
            >
              {
                !!pageLimit && pageLimit > pageCount && (
                  <>
                    <button
                      type="button"
                      onClick={() => setPageCount(pageCount + 1)}
                    >
                      <FontAwesomeIcon icon={['fas', 'caret-right']} />
                    </button>
                  </>
                )
              }
            </div>
          </div>
        </>
      </Modal>
    </>
  )
}

UserGuide.defaultProps = {
  minHeight: undefined,
  defaultOpen: false,
  callback: undefined,
}

export default UserGuide
